export function onClickAway(
	element: Element,
	callback: (e: Event) => void,
	...targets: Element[]
) {
	const listener = (event: Event) => {
		if (!element) return;
		if (typeof event.composedPath === 'function') {
			const path = event.composedPath();
			if (path.includes(element)) {
				return;
			}
		} else if (element.contains(event.target as Node)) {
			return;
		}
		callback(event);
	};

	if (!targets.length) {
		document.addEventListener('click', listener);
	} else {
		targets.forEach((target) => {
			if (!!target) {
				target.addEventListener('click', listener);
			}
		});
	}

	return () => {
		if (!targets.length) {
			document.removeEventListener('click', listener);
		} else {
			targets.forEach((target) => {
				if (!!target) {
					target.removeEventListener('click', listener);
				}
			});
		}
	};
}

export function hasAnimation(element: Element): boolean {
	// @ts-ignore
	return getComputedStyle(element, null)['animation-name'] !== 'none';
}
